export type ComplianceType = 'patent' | 'medical_insurance' | 'receipt'
export type ComplianceAlert = 'ok' | 'warning' | 'expired' | 'missing'

export const COMPLIANCE_TYPES_WITH_ALERTS: ComplianceType[] = ['patent', 'medical_insurance']

export function hasComplianceAlerts(type: ComplianceType): boolean {
  return COMPLIANCE_TYPES_WITH_ALERTS.includes(type)
}

export function isReceiptType(type: ComplianceType): boolean {
  return type === 'receipt'
}

export function formatReceiptAmount(amount: string | null | undefined): string {
  if (amount == null || amount === '') {
    return '—'
  }
  const num = Number(amount)
  if (!Number.isFinite(num)) {
    return String(amount)
  }
  return `${num.toLocaleString('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} ₽`
}

export interface ComplianceCurrentSummary {
  expires_at: string | null
  amount: string | null
  alert: ComplianceAlert | null
  record_id: number | null
}

export interface EmployeeComplianceSummary {
  patent: ComplianceCurrentSummary
  medical_insurance: ComplianceCurrentSummary
  receipt: ComplianceCurrentSummary
}

export interface ComplianceRecord {
  id: number
  employee_id: number
  type: ComplianceType
  expires_at: string
  amount: string | null
  created_by: number | null
  created_at: string
}

export const COMPLIANCE_LABELS: Record<ComplianceType, string> = {
  patent: 'Патент/разрешение',
  medical_insurance: 'Медицинский полис',
  receipt: 'Чеки',
}
